module.exports = __webpack_public_path__ + "static/media/icono_cereal_am.a71746fd.png";